import { themeColors } from './globalColors'

// JS mirror of styleSheets/tokens.scss — for inline styles in components.
export const spacing = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 }
export const radius = { sm: 8, md: 12, lg: 16, circle: '50%', pill: 999 }
export const fontSize = { display: 30, title: 17, amount: 16, body: 15, sub: 14, caption: 12 }
export const fontWeight = { regular: 400, semibold: 600, bold: 600, extrabold: 600 }
export const shadow = {
  card: '0 2px 10px rgba(0, 0, 0, 0.06)',
  hero: '0 8px 22px rgba(7, 105, 77, 0.25)',
  modal: '0 18px 50px rgba(0, 0, 0, 0.25)',
}
export const PAGE_GUTTER = 16
export const TAP_MIN = 44

// Brand gradient strings — JS mirror of $gradient-brand-* SCSS tokens
export const gradients = {
  brandGreen: 'linear-gradient(92.29deg, #103C2B 0%, #07694D 100%)',
  brandGold:  'linear-gradient(92.29deg, #8A5414 0%, #E6B95F 100%)',
  brandRed:   'linear-gradient(133.78deg, #E11D48 0%, #A31132 100%)',
}

// Semantic money helpers — positive = 應收 (owed to you), negative = 應付 (you owe)
export const balanceColor = (n) =>
  Number(n) > 0 ? themeColors.green700 : Number(n) < 0 ? themeColors.redText : themeColors.gray700
export const balanceLabel = (n) =>
  Number(n) > 0 ? '應收' : Number(n) < 0 ? '應付' : '已結清'
